<mat-toolbar color="primary" class="top-menubar" role="banner">
  <div class="top-menubar-left" [@toggleSidenav]="isSidenavOpen ? 'sidenav-open' : 'sidenav-closed'">
    <button (click)="toggleSidenav()" mat-icon-button class="margin-left-15 menu-icon" [attr.aria-label]="(isSidenavOpen ? 'navigation.closeNavigationMenu' : 'navigation.openNavigationMenu') | transloco"
      data-testid="top-menu-toggle-side-nav-button">
      @if (isSidenavOpen) {
        <mat-icon color="primary">menu</mat-icon>
      }
      @if (!isSidenavOpen) {
        <mat-icon color="white">menu</mat-icon>
      }
    </button>

    @if (isSidenavOpen) {
      <button (click)="navigateHome()" mat-button class="" [attr.aria-label]="'common.labels.homeButton' | transloco"
        data-testid="top-menu-home-button">
        <div class="">
          <img src="assets/reg-hub-logo-halloween-web.png" [alt]="'common.labels.logo' | transloco" class="logo">
        </div>
      </button>
    }
  </div>

  <span class="spacer"></span>

  @if (userAuthenticated) {
    <div class="top-menubar-search">
      <lib-search-pill data-testid="top-menu-search-bar"></lib-search-pill>
    </div>
  }

  <span class="spacer"></span>

  <div class="top-menubar-right margin-right-15">
    <!-- Content for the right part of the menubar -->
     @if (showLanguageSelector) {
      <lib-language-toggle></lib-language-toggle>
    }

    @if (!userAuthenticated) {
      <button mat-raised-button extended [matMenuTriggerFor]="matMenuUnAuthenticated" color="accent"
        data-testid="top-menu-account-button">
        <mat-icon>account_circle</mat-icon>
        {{ 'common.labels.account' | transloco }}
      </button>
    }
    <mat-menu #matMenuUnAuthenticated="matMenu">
      <button (click)="logIn()" mat-menu-item data-testid="top-menu-log-in-button">{{ 'common.labels.logIn' | transloco }}</button>
    </mat-menu>

    @if (userAuthenticated) {
      <button mat-button [matMenuTriggerFor]="matMenuAuthenticated"
        data-testid="top-menu-account-dropdown">
        <mat-icon color="white">account_circle_fill</mat-icon>
        {{ username }}
      </button>
    }
    <mat-menu #matMenuAuthenticated="matMenu">
      <button (click)="navigateToMyAccount()" mat-menu-item data-testid="top-menu-my-account-button">{{ 'common.labels.account' | transloco }}</button>
      <button (click)="logOut()" mat-menu-item data-testid="top-menu-log-out-button">{{ 'common.labels.logOut' | transloco }}</button>
    </mat-menu>
  </div>
</mat-toolbar>